import PptxGenJS from "pptxgenjs";
import domtoimage from "dom-to-image";

export const captureAndAddToPpt = ({
  element,
  headingRef,
  buttonRefs = [],
  tableRefs = [],
  fileName,
  slideWidth = 10,
  slideHeight = 5.7,
}) => {
  if (!element) {
    console.error("Element reference is required for capturing.");
    return;
  }
  headingRef.style.display = "block";
  buttonRefs.forEach((buttonRef) => {
    if (buttonRef?.style) buttonRef.style.display = "none";
  });
  tableRefs.forEach((tableRef) => {
    if (tableRef?.style) tableRef.style.display = "none";
  });

  element.style.border = "2px solid black";
  element.style.padding = "8px";

  setTimeout(() => {
    domtoimage
      .toPng(element, { scale: 2 })
      .then((dataUrl) => {
        const pptx = new PptxGenJS();
        const slide = pptx.addSlide();

        slide.addImage({
          data: dataUrl,
          x: 0,
          y: 0,
          w: slideWidth,
          h: slideHeight,
        });

        pptx.writeFile({ fileName });
      })
      .catch((error) => {
        console.error("Error capturing screenshot:", error);
      })
      .finally(() => {
        headingRef.style.display = "none";
        buttonRefs.forEach((buttonRef) => {
          if (buttonRef?.style) buttonRef.style.display = "flex";
        });
        tableRefs.forEach((tableRef) => {
          if (tableRef?.style) tableRef.style.display = "table-cell";
        });
        element.style.border = "";
        element.style.padding = "";
      });
  }, 300);
};
